import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Dimensions, Platform, TextInput } from 'react-native';
import { postSingle, Flex, Padding, Margin, Helpers, aboutAuthor, pageContent, FontFamily, FontWeight, Colors, input, button, Messages, article, Typo } from '../../styles/appStyles';
import TouchableOpacityLink from '../touchable-opacity-link';
import TouchableOpacityLinkExternal from '../touchable-opacity-link-external';
import CustomImage from '../custom-image';
import getImagePath from '../../utils/image-helper';
import { helpers } from '../../utils/helpers';
import ButtonGradient from '../button-gradient';
import PageBreak from '../page-break';
import VimeoVideo from '../../components/vimeo-video';

const PhoneIcon = getImagePath('img/app-available.png');
const PhoneIconDark = getImagePath('img/iPhoneDark.png');
const GooglePlayStoreIcon = getImagePath('img/google-play.png');
const AppleStoreIcon = getImagePath('img/app-store.png');

export class AppAvailablePoster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btnDisable: false,
            email: '',
            referralMsg: {
                enable: false,
                type: '', // error / success
                msg: ''
            },
        }
    }

    componentDidMount = () => {
    }

    signUp = () => {
        try {
            if (this.props.trackSignUp) {
                this.props.trackSignUp('', 'bottom banner');
            }
        }
        catch (error) {
            console.log("mix panel track error ==>", error);
        }
        if (helpers.isWeb()) {
            this.props.navigateWeb(`/sign-up?redirect=/`)
        } else {
            this.props.navigateApp('/sign-up', { redirect: '/', verifyRedirect: '/' });
        }
    }

    validateInput = (value) => {
        if (value) {
            this.setState({ btnDisable: false, email: value });
        } else {
            this.setState({ email: value, btnDisable: true })
        }
    }

    render() {
        let { email, btnDisable, referralMsg } = this.state;
        let { darkMode } = this.props;
        let webView = helpers.isWeb();
        const videoId = '524193673?&portrait=0&byline=0&title=0&background=1';
        const videoIdUrl = 'https://player.vimeo.com/video/524193673?&portrait=0&byline=0&title=0&background=1';
        let androidAppLink, iosAppLink;
        if (process.browser) {
            androidAppLink = {
                href: `https://play.google.com/store/apps/details?id=com.app.themorningcontext`
            }
            iosAppLink = {
                href: `https://apps.apple.com/in/app/the-morning-context/id1551672701`
            }
        } else {

        }
        return (
            <View style={[Margin.mb_6, Margin.mb_6, Helpers.textCenter, Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWeb1240, { marginTop: helpers.isDesktop() ? 130 : 75, paddingHorizontal: helpers.isDesktop() ? 0 : 0, width: helpers.isDesktop() ? '85%' : '100%', marginBottom: helpers.isDesktop() ? 135 : 60 }]}>
                <View style={[helpers.isDesktop() && Flex.row, Flex.alignCenter]}>
                    <View style={[helpers.isDesktop() && Flex.alignStart, { width: helpers.isDesktop() ? '40%' : '100%' }]}>
                        {helpers.isDesktop() ? <View style={{ paddingBottom: helpers.isDesktop() ? 25 : 0 }}>
                            <Text style={[helpers.isDesktop() && Helpers.textLeft, Padding.pb_1, { fontSize: helpers.isDesktop() ? 48 : 20, lineHeight: helpers.isDesktop() ? 58 : 24, fontFamily: FontFamily.abrilFatface, color: '#000' }, darkMode && { color: Colors.lightWhite }]}>Always there</Text>
                            {helpers.isDesktop() && <View style={{ width: 150, backgroundColor: darkMode ? Colors.lineColor : '#000', height: 2 }}></View>}
                        </View>
                            :
                            <View>
                                <View style={[article.headerWrapper, Padding.pb_2]}>
                                    <View style={[Flex.alignCenter]}>
                                        <View style={[Padding.ph_2, Helpers.titleBgWrap, { backgroundColor: darkMode ? Colors.darkBlackColorBg : 'white' }]}>
                                            <View style={[Helpers.borderBottom, darkMode && { borderBottomColor: Colors.lineColor }]}>
                                                <Text style={[Helpers.textCenter, Typo.h3_R, helpers.isDesktop() && Typo.h3_RDesktop, Margin.mb_0, { fontSize: 24 }, { fontFamily: FontFamily.abrilFatface, color: '#000' }, { fontSize: helpers.isDesktop() ? 34 : 20 }, darkMode && { color: Colors.lightWhite }]}>Always there</Text>
                                            </View>
                                        </View>
                                        <View style={[Helpers.titleLine, darkMode && { backgroundColor: Colors.lineColor }]}></View>
                                    </View>
                                </View>
                            </View>
                        }
                        <Text style={[helpers.isDesktop() && Helpers.textLeft, helpers.isDesktop() && Padding.pt_1, Padding.pb_3, { fontSize: helpers.isDesktop() ? 24 : 14, lineHeight: helpers.isDesktop() ? 38 : 24, fontFamily: FontFamily.merriweather, color: '#000' }, !helpers.isDesktop() && { paddingHorizontal: 20 }, !webView && { textAlign: 'center' }, darkMode && { color: Colors.lightWhite }]}>Download our app to access and view our stories on your mobile anytime, anywhere!</Text>
                        <View style={[Flex.row, !helpers.isDesktop() && { justifyContent: 'center', marginBottom: 15 }]}>
                            {/* <ButtonGradient
                                title={'SIGN UP'}
                                rootStyle={{
                                    btnWrapper: [button.primaryGradientBtn, { height: 46, borderRadius: 0, flex: 1, marginBottom: helpers.isDesktop() ? 0 : 15 }],
                                    btnText: [button.primaryGradientText, { fontSize: helpers.isDesktop() ? 18 : 14, paddingLeft: 50, paddingRight: 50, paddingTop: helpers.isDesktop() ? 0 : 10, paddingBottom: helpers.isDesktop() ? 0 : 10, fontWeight: '400' }]
                                }}
                                onClick={this.signUp}
                                disable={btnDisable}
                                darkMode={darkMode}
                            /> */}

                            <TouchableOpacityLinkExternal {...androidAppLink} newTab={true}>
                                <CustomImage
                                    source={GooglePlayStoreIcon}
                                    require={true}
                                    style={{ width: 155, height: 46, marginRight: helpers.isDesktop() ? 20 : 0, marginBottom: helpers.isDesktop() ? 0 : 15 }}
                                    webStyle={{ width: 155, height: 46, marginRight: 20, marginBottom: helpers.isDesktop() ? 0 : 15 }}
                                />
                            </TouchableOpacityLinkExternal>

                            <TouchableOpacityLinkExternal {...iosAppLink} newTab={true}>
                                <CustomImage
                                    source={AppleStoreIcon}
                                    require={true}
                                    style={{ width: 138, height: 46, marginRight: helpers.isDesktop() ? 20 : 0, marginBottom: helpers.isDesktop() ? 0 : 15 }}
                                    webStyle={{ width: 138, height: 46, marginRight: helpers.isDesktop() ? 20 : 0, marginBottom: helpers.isDesktop() ? 0 : 15 }}
                                />
                            </TouchableOpacityLinkExternal>
                        </View>
                    </View>
                    <View style={[helpers.isWeb() && { alignItems: helpers.isDesktop() ? 'flex-end' : 'center' }, { width: helpers.isDesktop() ? '60%' : '100%' }]}>
                        {helpers.isWeb() ?
                            <VimeoVideo videoId={videoId} home={true} />
                            :
                            <VimeoVideo videoIdUrl={videoIdUrl} home={true} />
                        }
                        {/*<CustomImage
                            source={darkMode ? PhoneIconDark : PhoneIcon}
                            require={true}
                            style={{ width: helpers.isDesktop() ? 400 : 300, height: helpers.isDesktop() ? 500 : 350 }}
                            webStyle={{ width: helpers.isDesktop() ? 400 : 300, height: helpers.isDesktop() ? 500 : 350 }}
                        /> */}
                    </View>
                </View>
                {/* <View style={[Flex.alignCenter, Padding.pt_4, Padding.pb_4, !helpers.isDesktop() && { paddingHorizontal: 20 }]}>
                    <Text style={{ fontSize: helpers.isDesktop() ? 34 : 24, lineHeight: helpers.isDesktop() ? 40 : 30, fontFamily: FontFamily.abrilFatface, textAlign: 'center' }}>Subscribe to get complete access and so much more</Text>
                    <View style={[Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWeb500, { maxWidth: 500 }]}>
                        <PageBreak style={[Margin.mt_1, Margin.mb_2]} />
                    </View>
                    <View style={[Margin.mt_3, helpers.isDesktop() && Flex.row, !helpers.isDesktop() && { width: '100%' }]}>
                        <View>
                            <TextInput
                                placeholder={'Email Id'}
                                placeholderTextColor={Colors.placeholderTextColor}
                                style={[input.Text, Padding.pt_1, Padding.pl_15, Padding.pb_1, Margin.mb_2, { backgroundColor: 'white', height: 46, borderColor: '#6C7AF6', borderWidth: 1, width: helpers.isDesktop() ? 400 : '100%' }]}
                                onChangeText={this.validateInput}
                                value={email}
                            />
                            {referralMsg.enable &&
                                <View style={[{}]}>
                                    <Text style={[referralMsg.type == 'success' ? Messages.successText : Messages.errorText]}>{referralMsg.msg}</Text>
                                </View>
                            }
                        </View>
                        <ButtonGradient
                            title={'SUBSCRIBE NOW'}
                            rootStyle={{
                                btnWrapper: [button.primaryGradient, { height: 46, borderRadius: 0, flex: 1, borderRadius: 0 }],
                                btnText: [button.primaryGradientText, { fontSize: 14, paddingLeft: 25, paddingRight: 25, paddingTop: helpers.isDesktop() ? 0 : 15, paddingBottom: helpers.isDesktop() ? 0 : 15 }]
                            }}
                            onClick={this.signUp}
                            disable={btnDisable}
                        />
                    </View>
                </View> */}
            </View>
        );
    }
}

export default AppAvailablePoster;